import { useParams, useHistory } from "react-router-dom";
import { useEffect, useState ,useRef} from "react";


export const OnBoarding = () =>{
    const history = useHistory();
    const { id } = useParams();
    const [nombre, setNombre] = useState('universo-')

    const newRoom = () => {
        history.push(nombre);
      };

    
    return (
        <>
         <div className="background-video">
        <iframe src="https://workshop.solsarratea.world/"></iframe>
         <div className="boarding">
            <h2>Bienvenides</h2> 
            <p>Este es un editor de GLSL colaborativo para la parte teorica, y jam. Esta basado en <a href="https://veda.gl/vedajs/" target="_blank">vedajs</a>. 
           </p>
            <div className="horizontal-bar">
                <p className="bar-text">
                     Acceder al editor para seguir la parte teorica ~`...☆*:.｡.o(≧▽≦)o.｡.:*☆...
                </p>

                <button className="bar-button" onClick={()=>history.push("workshop")}>
                     entrar
                </button>
            </div>
            
            <div className="horizontal-bar">
                <p className="bar-text">
                     Ingrese nombre para crear un editor colaborativo: 
                </p>
                <input className="bar-input"
                    type="text"
                    value={nombre}
                    onChange={(e) => {
                    setNombre(e.target.value);
                    }}
                    size="24"
                    id="name"
                />
                <button className="bar-button" onClick={newRoom}>
                     crear
                </button>
            </div>
            <p>Otros links de interes: </p>
            <ol>
                <li><a href="https://lashaderwiki.solsarratea.world/workshops/live-coding-por-toplap-bcn" target="_blank"> ShaderWiki:</a> todo el contenido del taller disponible aquí.</li>
            </ol>
        </div>
           
           
    </div>

        </>
      
    )
    }